:root {
  --font-display: 'Oswald', sans-serif;
  --font-mono: 'JetBrains Mono', 'IBM Plex Mono', 'Courier New', monospace;

  --color-bg: #fafafa;
  --color-surface: #ffffff;
  --color-surface-elevated: #f5f5f5;
  --color-border: #e5e5e5;
  --color-border-accent: #d4d4d4;
  --color-text: #171717;
  --color-text-muted: #737373;
  --color-text-dim: #a3a3a3;
  --color-accent: #2563eb;
  --color-accent-hover: #1d4ed8;
  --color-accent-dim: rgba(37, 99, 235, 0.12);
  --color-success: #16a34a;
  --color-warning: #ca8a04;
  --color-error: #dc2626;
  --color-info: #0891b2;

  --bg-primary: var(--color-bg);
  --bg-secondary: var(--color-surface);
  --bg-tertiary: var(--color-surface-elevated);
  --fg-primary: var(--color-text);
  --fg-secondary: var(--color-text-muted);
  --fg-muted: var(--color-text-dim);
  --border-color: var(--color-border);
  --accent-error: var(--color-error);
  --accent-success: var(--color-success);
  --accent-warn: var(--color-warning);
  --selection-bg: var(--color-accent-dim);
  --accent-run: var(--color-accent);
}

:root[data-theme="dark"] {
  --color-bg: #0a0a0a;
  --color-surface: #111111;
  --color-surface-elevated: #1a1a1a;
  --color-border: #2a2a2a;
  --color-border-accent: #3a3a3a;
  --color-text: #e0e0e0;
  --color-text-muted: #a0a0a0;
  --color-text-dim: #666666;
  --color-accent: #3b82f6;
  --color-accent-hover: #2563eb;
  --color-accent-dim: rgba(59, 130, 246, 0.15);
  --color-success: #4ade80;
  --color-warning: #fbbf24;
  --color-error: #f87171;
  --color-info: #22d3ee;
}

@media (prefers-color-scheme: dark) {
  :root:not([data-theme="light"]) {
    --color-bg: #0a0a0a;
    --color-surface: #111111;
    --color-surface-elevated: #1a1a1a;
    --color-border: #2a2a2a;
    --color-border-accent: #3a3a3a;
    --color-text: #e0e0e0;
    --color-text-muted: #a0a0a0;
    --color-text-dim: #666666;
    --color-accent: #3b82f6;
    --color-accent-hover: #2563eb;
    --color-accent-dim: rgba(59, 130, 246, 0.15);
    --color-success: #4ade80;
    --color-warning: #fbbf24;
    --color-error: #f87171;
    --color-info: #22d3ee;
  }
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body, #root {
  height: 100%;
  overflow: hidden;
}

body {
  font-family: var(--font-mono);
  font-size: 14px;
  line-height: 1.5;
  color: var(--color-text);
  background: var(--color-bg);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

::selection {
  background: var(--color-accent-dim);
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: var(--color-border);
  border-radius: 0;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--color-text-dim);
}

::-webkit-scrollbar-corner {
  background: transparent;
}

.grid-bg {
  position: fixed;
  inset: 0;
  background-image:
    linear-gradient(var(--color-border) 1px, transparent 1px),
    linear-gradient(90deg, var(--color-border) 1px, transparent 1px);
  background-size: 50px 50px;
  background-position: center center;
  opacity: 0.2;
  pointer-events: none;
  z-index: 0;
}

.scanlines {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 1;
  opacity: 0.02;
  background: repeating-linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.1),
    rgba(0, 0, 0, 0.1) 1px,
    transparent 1px,
    transparent 2px
  );
}

.noise {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 1;
  opacity: 0.015;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E");
}

.animate-scanline {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, transparent, var(--color-accent-dim), transparent);
  animation: scanline 8s linear infinite;
  pointer-events: none;
  z-index: 50;
}

@keyframes scanline {
  0% { transform: translateY(-100%); }
  100% { transform: translateY(100vh); }
}

@keyframes pulse-ring {
  0% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}
